import HrGeneralLeave from "app/models/hrGeneralLeave"
import { Action, Types } from "./hrGeneralLeaves.actions"

export type HrGeneralLeavesState = {
  errors: {}
  loading: boolean
  data: HrGeneralLeave[]
}

const initialState: HrGeneralLeavesState = {
  errors: {},
  loading: false,
  data: [],
}

export default (state = initialState, action: Action): HrGeneralLeavesState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.hrGeneralLeaves,
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }
    case Types.POST:
      return {
        ...state,
        loading: true,
      }

    case Types.POST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...state.data, ...action.payload.hrGeneralLeaves],
      }

    case Types.POST_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.DELETE:
      return {
        ...state,
        loading: true,
      }

    case Types.DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.filter(
          item => !action.payload.hrGeneralLeaves.find(leave => Number(leave.id) === Number(item.id)),
        ),
      }

    case Types.DELETE_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
